import React from 'react';
import './About.css'; // אל תשכח לכלול את קובץ הסגנונות

export default function About() {
  return (
    <div className="page about fade-in">
      <h2 className="animated-title">🥐 אודות פרי מטיב 🥐</h2>
      <p className="slide-up">
        🥗 <strong>פרי מטיב</strong> הוא בית קפה-מעדנייה כשר למהדרין הממוקם ברחוב חיים עוזר 13, בלב פתח תקווה.
        המקום מציע חוויית אירוח חמימה, עם תפריט עשיר ומוקפד הכולל מנות בוקר, שייקים, מאפים טריים,
        סלטים, שקשוקה, יוגורט, אסאי ועוד.
      </p>
      <p className="slide-up delay-1">
      🍴 המקום מעוצב בקפידה עם דגש על פרטים קטנים, מה שמעניק תחושת חמימות וביתיות.
        העיצוב כולל אלמנטים ירוקים ותאורה נעימה, היוצרים סביבה מזמינה לישיבה.
      </p>
      <p className="slide-up delay-2">
        🕒 העסק נפתח מדי יום בשעה 7:00 בבוקר, ומציע שירות לאורך שעות היום (שעות סגירה משתנות).
      </p>
      <p className="slide-up delay-3">
        📍 ממוקם ברחוב חיים עוזר 13, בלב אזור מתחדש של פתח תקווה. אם אתה מחפש מקום נעים עם אוכל איכותי
        וכשרות מהודרת – פרי מטיב הוא בחירה מצוינת.
      </p>
      <p className="slide-up delay-4">
        📞 טלפון: 050-2318757 | ✉️ דוא"ל: later@gmail.com 
      </p>
      <img
        src="/images/counter.jpg"
        alt="פנים בית הקפה"
        className="about-img zoom-in"
      />
    </div>
  );
}
